import Vue from 'vue';
import Vuex from 'vuex';

import {getField, updateField} from 'vuex-map-fields';
import {Auth, User, Application, Localization} from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Auth,
    User,
    Application,
    Localization
  },
  state: {}
});